import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsBox from '@medflex/components/stories/SettingsBox';
import Button from '@medflex/components/stories/Button';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { UserTagTypes } from '@medflex/shared-types';
import useModal from '../../hooks/useModal';
import useUserProfile from '../../hooks/useUserProfile';

const UserTagsModule = () => {
  const { t } = useTranslation('physician');
  const { userTags } = useUserProfile();
  const { open } = useModal();

  return (
    <div data-component="UserTagsModule">
      <header className="mb-6 flex items-center">
        <h2 className="text-2xl font-semibold">{t('UserTagsModule.title')}</h2>
      </header>
      <p className="mb-12">{t('UserTagsModule.description')}</p>

      <div className="flex flex-col space-y-6">
        <Button kind="link" onClick={() => open({ modal: 'userTagsEdit' })}>
          <PlusCircleIcon className="w-6 h-6" />
          <p className="ml-2">{t('UserTagsModule.create')}</p>
        </Button>
        {userTags &&
          Object.values(userTags).map(({ id, value, type, description }) => (
            <SettingsBox
              title={value}
              key={id}
              canEdit
              canDelete={type !== UserTagTypes.SYSTEM}
              truncate
              onEdit={() => open({ modal: 'userTagsEdit', id })}
              onDelete={() => open({ modal: 'userTagsDelete', id })}
            >
              {description && <p className="mb-2">{description}</p>}
            </SettingsBox>
          ))}
      </div>
    </div>
  );
};

export default UserTagsModule;
